<template>
  <svg viewBox="0 -8 34 40" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M29,0H3A3,3,0,0,0,0,3V25a3,3,0,0,0,3,3H5a1,1,0,0,0,0-2H3a1,1,0,0,1-1-1V8H30V25a1,1,0,0,1-1,1H27a1,1,0,0,0,0,2h2a3,3,0,0,0,3-3V3A3,3,0,0,0,29,0ZM2,6V3A1,1,0,0,1,3,2H29a1,1,0,0,1,1,1V6Z"
        fill="#2196f3"
      />
      <path d="M27,12H25a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z" fill="#2196f3" />
      <path d="M7,16H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z" fill="#2196f3" />
      <path d="M7,12H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z" fill="#2196f3" />
      <path
        d="M16,32a8,8,0,0,1-5.29-2H8a1,1,0,0,1-.89-1.45L8.3,26.16A7.93,7.93,0,0,1,8,24a8,8,0,1,1,8,8ZM9.62,28h1.49a.94.94,0,0,1,.69.29A6,6,0,1,0,10,24a6.1,6.1,0,0,0,.32,1.93,1,1,0,0,1-.05.77Z"
        fill="#2196f3"
      />
      <path
        d="M18,23H17V22a1,1,0,0,0-2,0v1H14a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V25h1a1,1,0,0,0,0-2Z"
        fill="#f44336"
      />
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "SoliciTelessaudeIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
